import { HttpClient } from '@angular/common/http';
import { Component, OnInit, ViewChild } from '@angular/core';
import { MatTabGroup } from '@angular/material/tabs';
import { DatatableComponent } from '@swimlane/ngx-datatable';
export interface EmplNotification {
  appName: string;
  eventName: string;
  notify: boolean;
  mail: boolean;
  message: boolean;
  portal: boolean;
  status: string;
  allowOver: string;
  app_id: number;
  event_id: number;
  selectedType: string[];
}
@Component({
  selector: 'app-employee-notification',
  templateUrl: './employee-notification.component.html',
  styleUrls: ['./employee-notification.component.scss'],
})
export class EmployeeNotificationComponent implements OnInit {
  internalTypeNew = '';
  internalType = 'internalType';
  rowIndex = null;
  @ViewChild('tabs') tabGroup: MatTabGroup;
  notification: EmplNotification;
  selected = [];
  dataForInsert = {
    EVENT_NAME: 'TEST9',
    APP_ID: 1,
  };
  showtable: boolean = false;
  @ViewChild('table') table: DatatableComponent;
  rows = [];
  isEditable = {};
  filteredList: EmplNotification[] = [];
  notifications: Notification[] = [];
  constructor(private http: HttpClient) { }

  ngOnInit() {
    this.fetchData();
  }

  fetchData() {
    this.filteredList = [];
    this.showtable = false;
    this.http
      .get('/notification-service/fetching-notifications-for-employee')
      .subscribe((res) => {
        console.log(res);
        const restemp: any = res;
        for (let m of restemp.data) {
          const eventName = m.eventName;
          const appName = m.appName;
          let notify = true;
          let mail = true;
          let message = true;
          let portal = true;
          let selectedTypes: string[] = [];
          for (let s of m.listMapForNotificationTypeTmpltIdOverriddenEmployee) {
            if (s.NOTIFICATION_TYPE === 111) {
              notify = false;
              if (s.ACTIVE_FLAG === 1) {
                selectedTypes.push('internalType');
              }
            } else if (s.NOTIFICATION_TYPE === 112) {
              mail = false;
              if (s.ACTIVE_FLAG === 1) {
                selectedTypes.push('mailType');
              }
            } else if (s.NOTIFICATION_TYPE === 113) {
              message = false;
              if (s.ACTIVE_FLAG === 1) {
                selectedTypes.push('messageType');
              }
            }
            else if (s.NOTIFICATION_TYPE === 118) {
              portal = false;
              if (s.ACTIVE_FLAG === 1) {
                selectedTypes.push('portalType');
              }
            }
            else {
            }
          }
          const status = m.status;
          const allowOver = m.isOverRiddenByEmployee;
          const event_id = m.eventId;
          const app_id = m.appId;
          this.filteredList.push({
            eventName: eventName,
            appName: appName,
            notify: notify,
            mail: mail,
            message: message,
            portal: portal,
            status: status,
            allowOver: allowOver,
            event_id: event_id,
            app_id: app_id,
            selectedType: selectedTypes
          });
          console.log(this.filteredList);
        }
        this.showtable = true;
      });
  }
  updateFilter(filterValue) {
    const lowerValue = filterValue.toLowerCase();

    this.filteredList = this.filteredList.filter(
      (item) =>
        item.eventName.toLowerCase().indexOf(lowerValue) !== -1 || !lowerValue
    );
  }

  mailChange(row) {
    if (!row.mail) {
      const dataForMail = {
        event_id: 24,
        app_id: 1,
        notification_type: 112,
        active_flag: 0,
      };
      dataForMail.event_id = row.event_id;
      dataForMail.app_id = row.app_id;
      console.log(row, dataForMail);
      if (!row.selectedType.includes('mailType')) {
        dataForMail.active_flag = 1;
        console.log(dataForMail);
        this.http
          .post('/notification-service/update-employee-preference', dataForMail)
          .subscribe((res) => {
            console.log(res);
            this.fetchData();
          });
      } else {
        dataForMail.active_flag = 0;
        this.http
          .post('/notification-service/update-employee-preference', dataForMail)
          .subscribe((res) => {
            console.log(res);
            this.fetchData();
          });
      }
    }
  }
  internalChange(row) {
    if (!row.notify) {
      console.log(row.selectedType.includes('internalType'));
      const dataForMail = {
        event_id: 24,
        app_id: 1,
        notification_type: 111,
        active_flag: 0,
      };
      dataForMail.event_id = row.event_id;
      dataForMail.app_id = row.app_id;
      console.log(row, dataForMail);
      if (!row.selectedType.includes('internalType')) {
        dataForMail.active_flag = 1;
        console.log(dataForMail);
        this.http
          .post('/notification-service/update-employee-preference', dataForMail)
          .subscribe((res) => {
            console.log(res);
            this.fetchData();
          });
      } else {
        dataForMail.active_flag = 0;
        this.http
          .post('/notification-service/update-employee-preference', dataForMail)
          .subscribe((res) => {
            console.log(res);
            this.fetchData();
          });
      }
    }
  }
  smsChange(row) {
    if (!row.message) {
      const dataForMail = {
        event_id: 24,
        app_id: 1,
        notification_type: 113,
        active_flag: 0,
      };
      dataForMail.event_id = row.event_id;
      dataForMail.app_id = row.app_id;
      console.log(row, dataForMail);
      if (!row.selectedType.includes('messageType')) {
        dataForMail.active_flag = 1;
        console.log(dataForMail);
        this.http
          .post('/notification-service/update-employee-preference', dataForMail)
          .subscribe((res) => {
            console.log(res);
            this.fetchData();
          });
      } else {
        dataForMail.active_flag = 0;
        this.http
          .post('/notification-service/update-employee-preference', dataForMail)
          .subscribe((res) => {
            console.log(res);
            this.fetchData();
          });
      }
    }
  }
  portChange(row) {
    if (!row.portal) {
      const dataForMail = {
        event_id: 24,
        app_id: 1,
        notification_type: 118,
        active_flag: 0,
      };
      dataForMail.event_id = row.event_id;
      dataForMail.app_id = row.app_id;
      console.log(row, dataForMail);
      if (!row.selectedType.includes('portalType')) {
        dataForMail.active_flag = 1;
        console.log(dataForMail);
        this.http
          .post('/notification-service/update-employee-preference', dataForMail)
          .subscribe((res) => {
            console.log(res);
            this.fetchData();
          });
      } else {
        dataForMail.active_flag = 0;
        this.http
          .post('/notification-service/update-employee-preference', dataForMail)
          .subscribe((res) => {
            console.log(res);
            this.fetchData();
          });
      }
    }
  }
  onTypeChange(row, type) {
    //  console.log(row, type);
  }
  changeT() {
    this.internalTypeNew = '';
  }
}
